import { useState, useEffect } from 'react';
import parseRem from '../../utils/parse-rem';

const LocalNavigationItem = (props) => {
  const { linkText, widgetIdToLink } = props;
  let header = '';
  if (typeof window !== 'undefined') {
    header = document.querySelector('header');
  }
  const headerHeight = header.offsetHeight;
  const [userScrolled, setUserScrolled] = useState(false);

  useEffect(() => {
    window.addEventListener('userScroll', () => {
      setUserScrolled(true);
    });
  }, []);

  const setScrollPaddingCssVariable = (paddingValue) => {
    const htmlElement = document.querySelector('html');
    htmlElement.style.setProperty('--scroll-padding-top-value', parseRem(paddingValue));
  };

  const setScrollPadding = () => {
    window.dispatchEvent(new HashChangeEvent('hashchange'));
    const localNavHeight = document.querySelector('.local-nav').offsetHeight;
    const headerIsHidden = header.style.marginTop !== '0px' && header.style.marginTop !== '';
    const elementToScrollTo = document.getElementById(`${widgetIdToLink}`);
    const elementIsAboveTopOfViewport =
      elementToScrollTo.getBoundingClientRect().top < headerHeight + localNavHeight;
    const headerWillDisplayAfterScroll = headerIsHidden && elementIsAboveTopOfViewport;
    const headerPlusLocalNavHeight = headerHeight + localNavHeight;

    if (headerWillDisplayAfterScroll) {
      setScrollPaddingCssVariable(headerHeight);
    } else if (!headerIsHidden && elementIsAboveTopOfViewport) {
      setScrollPaddingCssVariable(headerPlusLocalNavHeight);
    } else if (headerIsHidden && !elementIsAboveTopOfViewport) {
      setScrollPaddingCssVariable(localNavHeight);
    } else if (!headerIsHidden && !elementIsAboveTopOfViewport && !userScrolled) {
      setScrollPaddingCssVariable(headerPlusLocalNavHeight);
    } else if (!headerIsHidden && !elementIsAboveTopOfViewport) {
      setScrollPaddingCssVariable(localNavHeight * 2);
    } else {
      setScrollPaddingCssVariable(headerPlusLocalNavHeight);
    }
    window.scrollTo(0, elementToScrollTo.offsetTop);
  };

  return (
    <a onClick={setScrollPadding} className="non-default-link" href={`#${widgetIdToLink}`}>
      {linkText}
    </a>
  );
};

export default LocalNavigationItem;
